import Vue from 'vue'

Vue.filter('numberFormat', function (val) {
  if (typeof val === 'string') {
    val = Number(val)
  }

  return val.toLocaleString('ru')
})
